import { DadosBasicosPjDTO } from "src/app/cnpj/model/dados-basicos-pj-dto";

export const DADOS_BASICOS_PJ_DTO: DadosBasicosPjDTO = {
  "cnpj": "02036483000614",
  "nomeEmpresarial": "KXMVQMHMVWD NX OIWUQD FIXNGVXU WGVXPXVQEXU DVNW",
  "situacaoNoCnpj": {
    "codigo": "08",
    "descricao": "Baixada"
  },
  "nomeFantasia": "KXMVQMHMVWD VHEHU",
  "nire": "00000000000",
  "unidadeReceita": {
    "codigo": "0812400",
    "descricao": "DRF JUNDIAÍ-SP"
  },
  "dataPrimeiroEstabelecimento": "1997-07-25",
  "dataPrimeiroVinculo": "1997-01-01",
  "dataAbertura": "1997-07-25",
  "dataSituacao": "2010-08-27",
  "motivo": {
    "codigo": "01",
    "descricao": "Extinção Por Encerramento Liquidação Voluntária"
  },
  "responsavelTitularCnpj": {
    "cpf": "85122220425",
    "nome": "HVITRL XZIOLH ILXSZ"
  },
  "situacaoCpfResponsavel": {
    "codigo": "0",
    "descricao": "Regular"
  },
  "qualificacaoResponsavel": {
    "codigo": "05",
    "descricao": "Administrador"
  },
  "processoInscricaoOficio": "",
  "prepostoEmpresa": null,
  "porteEmpresa": "DEMAIS",
  "correioEletronico": "laercio.gonela@continental-corporation.com",
  "endereco": "AVENIDA NGAGH NH KWTQWU, 2422 - SALA  B",
  "bairro": "JARDIM SANTA LUCIA",
  "municipio": "VARZEA PAULISTA",
  "uf": "SP",
  "cep": "13220015",
  "telefone": "(11) 4596-8153",
  "segundoTelefone": "",
  "fax": "(11) 4606-1558",
  "enteFederativo": "",
  "tipoEstatal": "",
  "capitalSocial": "883.551.088,00",
  "naturezaJuridica": {
    "codigo": "2062",
    "descricao": "Sociedade Empresária Limitada"
  },
  "atividadeEconomicaPreferencial": {
    "codigo": "2943300",
    "descricao": "Fabricação de peças e acessórios para o sistema de freios de veículos automotores"
  },
  "atividadesEconomicasSecundarias": [
    {codigo: "1", descricao: "Fabricação de peças e acessórios para o sistema de direção e suspensão de veículos automotores"},
    {codigo: "2", descricao: "Fabricação de peças e acessórios para o sistema de transmissão de veículos automotores"},
    {codigo: "3", descricao: "Fabricação de peças e acessórios para o sistema de escapamento de veículos automotores"},
  ],
  "cnpjAdministrador": null,
  "unidadeAduaneira": {
    "codigo": "0817400",
    "descricao": "ALF SÃO PAULO II-SP"
  },
  "contadorCpf": null,
  "crcContadorCpf": "",
  "contadorCnpj": null,
  "crcContadorCnpj": ""
};
